module.exports = __webpack_public_path__ + "static/media/photos.4cb444ec.svg";